import React from "react";

const Filters = ({ filters, setFilters }) => (
  <div className="bg-gray-700 p-2 sm:p-4 rounded-lg shadow mb-4 sm:mb-8">
    <div className="flex flex-row gap-2 sm:gap-4">
      {/* Min Trades Card */}
      <div className="flex-1 bg-gray-800 p-2 sm:p-4 rounded-lg min-w-0">
        <label className="text-xs sm:text-sm font-bold text-pink-500 mb-1 sm:mb-2 block">
          Min Trades: {filters.minTrades}
        </label>
        <input
          type="range"
          min="0"
          max="100"
          value={filters.minTrades}
          onChange={(e) =>
            setFilters({ ...filters, minTrades: Number(e.target.value) })
          }
          className="w-full"
        />
      </div>

      {/* Min Profit % Card */}
      <div className="flex-1 bg-gray-800 p-2 sm:p-4 rounded-lg min-w-0">
        <label className="text-xs sm:text-sm font-bold text-pink-500 mb-1 sm:mb-2 block">
          Min Profit %: {filters.minProfit}
        </label>
        <input
          type="range"
          min="-100"
          max="1000"
          step="10"
          value={filters.minProfit}
          onChange={(e) =>
            setFilters({ ...filters, minProfit: Number(e.target.value) })
          }
          className="w-full"
        />
      </div>

      {/* Min Volume Card */}
      <div className="flex-1 bg-gray-800 p-2 sm:p-4 rounded-lg min-w-0">
        <label className="text-xs sm:text-sm font-bold text-pink-500 mb-1 sm:mb-2 block">
          Min Volume (BTC): {filters.minVolume}
        </label>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={filters.minVolume}
          onChange={(e) =>
            setFilters({ ...filters, minVolume: Number(e.target.value) })
          }
          className="w-full"
        />
      </div>
    </div>
  </div>
);

export default Filters;
